import { render, staticRenderFns } from "./CompanyAnnouncements.vue?vue&type=template&id=0349beb2&"
import script from "./CompanyAnnouncements.vue?vue&type=script&lang=js&"
export * from "./CompanyAnnouncements.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports